var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": 3,
    d: "M4.8,1.6V.8A.8.8,0,0,1,5.6,0H8.8a.8.8,0,0,1,.8.8v.8h3.2a1.6,1.6,0,0,1,1.6,1.6V4a1.6,1.6,0,0,1-1.6,1.6h-.108l-.544,8.16A2.4,2.4,0,0,1,9.756,16H4.66a2.4,2.4,0,0,1-2.392-2.236L1.708,5.6H1.6A1.6,1.6,0,0,1,0,4V3.2A1.6,1.6,0,0,1,1.6,1.6Zm8,1.6H1.6V4H12.8ZM3.312,5.6l.552,8.056a.8.8,0,0,0,.8.744h5.1a.8.8,0,0,0,.8-.748L11.088,5.6ZM5.6,6.4a.8.8,0,0,1,.8.8v5.6a.8.8,0,1,1-1.6,0V7.2A.8.8,0,0,1,5.6,6.4Zm3.2,0a.8.8,0,0,1,.8.8v5.6a.8.8,0,0,1-1.6,0V7.2A.8.8,0,0,1,8.8,6.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1fceacb49067b19117c023bcae4173ba.svg";
export { ForwardRef as ReactComponent };